import {
  findIndex as _findIndex,
  isEmpty as _isEmpty,
  map as _map,
} from 'lodash-es';

const state = {
  options: [],
  isCurrentlyEditing: [
    {
      name: 'sidebar_bg_color',
      value: false,
    },
    {
      name: 'sidebar_menu_hover_color',
      value: false,
    },
    {
      name: 'sidebar_font_color',
      value: false,
    },
    {
      name: 'header_bg_color',
      value: false,
    },
    {
      name: 'top_menu_hover_color',
      value: false,
    },
    {
      name: 'header_font_color',
      value: false,
    },
  ],
  defaultOptions: [
    {
      name: 'sidebar_bg_color',
      value: '#353535',
    },
    {
      name: 'sidebar_menu_hover_color',
      value: '#555555',
    },
    {
      name: 'sidebar_font_color',
      value: '#A2A3B7',
    },
    {
      name: 'header_bg_color',
      value: '#F9B418',
    },
    {
      name: 'top_menu_hover_color',
      value: '#4d5995',
    },
    {
      name: 'header_font_color',
      value: '#F1C40F',
    },
    {
      name: 'primary_button_background_color',
      value: '#1976D2',
    },
    {
      name: 'primary_button_hover_color',
      value: '#1976D2',
    },
    {
      name: 'primary_button_text_color',
      value: '#ffffff',
    },
    {
      name: 'secondary_button_background_color',
      value: '#424242',
    },
    {
      name: 'secondary_button_hover_color',
      value: '#424242',
    },
    {
      name: 'secondary_button_text_color',
      value: '#ffffff',
    },
  ],
};

const mutations = {
  setOptions: (st, data) => {
    st.options = data;
  },
  setEditingMode: (st, data) => {
    st.isCurrentlyEditing = _map(st.isCurrentlyEditing, (item) => {
      return {
        name: item.name,
        value: data.name === item.name ? data.value : false,
      };
    })
  },
  setOption: (st, data) => {
    if (_isEmpty(st.options)) {
      return;
    }
    const index = _findIndex(st.options, {
      name: data.option
    });
    if (index === -1) {
      return;
    }
    st.options[index].value = data.value;
  },
};

const actions = {
  getOptions(context, payload) {
    return this._vm.axios('/options/dealer', {
      params: {
        email: payload,
      },
    });
  },
  setOption({ commit }, payload) {
    commit('setOption', payload);
  },
  setEditingOption({ commit }, payload) {
    commit('setEditingMode', payload);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
